import { COLORS } from "~components/Common/Theme/Colors/index.jsx";

// TODO: large-tablet should be set to 1024px. Many components trigger
//  desktop layouts at 1025px, meaning any tablet-specific styles set inside
//  large-tablet as a max-width will remain until 1026px. More investigation is
//  needed across all breakpoints.
export const BREAKPOINTS = {
  giant: `2200px`,
  "large-desktop": `1600px`,
  desktop: `1340px`,
  "small-desktop": `1260px`,
  "large-tablet": `1025px`,
  tablet: `769px`,
  "small-tablet": `660px`,
  "large-mobile": `500px`,
  mobile: `400px`,
  "small-mobile": `375px`
};

export const breakpoint = (key, bound = `min`) => {
  if (!BREAKPOINTS?.[key]) {
    return `@media `;
  }

  return `@media only screen and (${bound}-width: ${BREAKPOINTS[key]}) `;
};

export const getColor = (color) => {
  if (color?.charAt(0) === `#`) {
    return color;
  }

  return COLORS[color] || null;
};
